/**
 * @type {{ regular: string; medium: string; bold: string; light: string }}
 */
export const fontStyles = { // L1
    regular: "\"nunito_sans_regular\", sans-serif",
    medium: "\"nunito_sans_semibold\", sans-serif",
    bold: "\"nunito_sans_bold\", sans-serif",
    light: "\"nunito_sans_light\", sans-serif"
};

/*

NOTES

[L1]
style    | how to use it in a styled-component
--------------------------------------------------------------
regular  | font-family: ${({ theme }) => theme.text.regular};
medium   | font-family: ${({ theme }) => theme.text.medium};
bold     | font-family: ${({ theme }) => theme.text.bold};
light    | font-family: ${({ theme }) => theme.text.light};

*/
